import React from "react";
import { Link, useHistory} from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { getReportMenuItems, getMainDrawerMenuTop, mainDrawerMenuBottom, settingsDrawer } from "../models/menus";
import {AppBar, CssBaseline, Divider, Drawer, Hidden, Typography, IconButton, Tooltip, Box} from "@material-ui/core";
import { Icon, List, ListItem, ListItemIcon, ListItemText, SvgIcon, Toolbar } from "@material-ui/core";
import { Chip, Menu, MenuItem } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { AccountCircle, Person, ExitToApp } from "@material-ui/icons";
import MyRoutes from "./route";
import { useEffect, useState } from 'react';
import { AuthService } from '../_services/auth.service';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import NotificationPanel from './notification/NotificationPanel'
import * as userPermissionsConstants from "../_constants/user.permissions.constants";
import { PermissionDenied } from "./PermissionDenied";
import {   
    selectVenue,   
    getReportViews as getReportViewsAction
} from "../_actions/venue.actions";
import {   
    useSessionStorage,   
} from "./_common/useSessionStorage"; 
import {ErrorBoundary } from './_common/ErrorBoundary';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import DashboardBusinessHoursWarning from "./admin/dashboards/DashboardBusinessHoursWarning";
import {useLocation} from "react-router-dom";

const authService = new AuthService();


const drawerWidth = 255;

const login = () => {
    authService.login();
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& .MuiListItemIcon-root": {
      minWidth: "28px",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "1.4rem",
    },
    ...theme.scrollbar,
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    background: theme.palette.common.white,
    zIndex: theme.zIndex.drawer + 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  drawerPaper: {
    width: drawerWidth,
    background: theme.palette.menu.background,
    color: theme.palette.menu.color,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    minHeight: "100vh",
    backgroundColor: theme.palette.color.primary.background,
    //paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  pageContent: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    minHeight: 0,
    paddingTop: theme.spacing(3),
  },
  icon: {
    color: null,
  },
  backToMainButton: {
    "&:hover, &.Mui-focusVisible": {
      backgroundColor: theme.palette.color.primary.darkHover,
    },
    marginLeft: "-7px",
    marginRight: "5px",
  },
  backToMainIcon: {
    color: "white",
    // marginLeft: "-7px",
    // marginRight: "5px"
  },
  menuItemName: {
    fontSize: 14,
    fontWeight: 400,
  },
  menuItem: {
    width: `calc(${drawerWidth}px)`,
    transition: null,
  },
  notSelectedMenuItem: {
    color: theme.palette.menu.color,
    fill: theme.palette.menu.color,
    "&:hover": {
      //marginLeft: "5px",
      color: "white",
      fill: "white",
    },
  },
  selectedMenuItem: {
    color: "white",
    fill: "white",
    backgroundColor: `${theme.palette.menu.selectedBackground} !important`,
    "&:hover": {
      color: "white",
      fill: "white",
      backgroundColor: theme.palette.menu.selectedBackground,
    },
  },
  nestedMenuItem: {
    paddingLeft: theme.spacing(5),
    "&:hover": {
      color: "white",
      //marginLeft: "5px",
      // marginRight: "0px"
    },
  },
  touchRippleRoot: {
    color: theme.palette.menu.selectedBackground,
  },
  settingsSubmenu: {
    fontSize: 18,
    fontWeight: 500,
    color: "white",
  },
  divider: {
    background: "#304046",
  },
  currentVenueLabel: {
    color: theme.palette.color.secondary.main,
    paddingRight: "5px",
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  currentVenueName: {
    color: "#000031",
    flexGrow: 1,
    textOverflow: "ellipsis",
    overflow: "hidden",
    minWidth: 0,
  },
  title: {
    flexGrow: 1,
    color: "#000",
  },
  logoBox: {
    minHeight: "64px",
  },
  logo: {
    width: 150,
    margin: 18,
    //marginBottom: "10px",
  },

  accountCircle: {
    fill: theme.palette.color.primary.dark,
  },
  userProfileMenuIcon: {
    marginRight: "5px",
    fontSize: "large",
  },
  backToMain: {
    width: `calc(${drawerWidth - 21}px)`,
  },
  helpContainer: {
    //display: (window.screen.width < 1024 ? "none" : "block"),
    position: "relative",
  },
  helpButton: {
    position: "absolute",
    right: 5,
    bottom: 5,
    padding: "5px 5px",
    borderRadius: "60px",
    border: "none",
    backgroundColor: theme.palette.color.primary.main /* Change this to your preferred color */,
    color: "white" /* Change this to your preferred color */,
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: theme.palette.color.primary.main10Darker  /* Change this to your preferred color */,
    },
  },
  helpIcon: {
    fontSize: "40px",
  },
  helpIframe: {
    display: "none",
    position: "absolute",
    bottom: "60px" /* Adjust this to account for the larger button */,
    right: 10,
    zIndex: 1,
    border: "1px solid silver",
    boxShadow: "5px",
  },
  afterHoursMainCurtain: {
    backgroundColor: theme.palette.color.secondary.main,
    opacity: 0.3,
    pointerEvents: "none",
    zIndex: 2,
  },
  afterHoursToolbarCurtain: {
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
}));



function Home(props) {
    const dispatch = useDispatch();
    const classes = useStyles();    
    const theme = useTheme();
    const { window : windowProp} = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);   
    const [user, setUser] = React.useState(null);
    const [userAvailablePages, setUserAvailablePages] = React.useState([]);
    const open = Boolean(anchorEl);

    // Whether to display the main menu or the Settings sub-menu.
    const [showMainMenu, setShowMainMenu] = useState(true);
    // Remember the last open page for the main menu and for the Settings submenu.
    const history = useHistory();
    const [mainMenuLink, setMainMenuLink] = useState('/home');
    const [settingsMenuLink, setSettingsMenuLink] = useState('/settings-datasources');

    useEffect(() => {
        setShowMainMenu(!history.location.pathname.startsWith("/settings-"));
    }, [history.location.pathname]);

    useEffect(() => {
        const handleWindowPop = (e) => {
            const pathname = document.location.pathname;
            const newShowMainMenu = !pathname.startsWith("/settings-");
            setShowMainMenu(newShowMainMenu);
            if (newShowMainMenu) {
                let foundItem = null;
                foundItem = foundItem || getMainDrawerMenuTop(reportViews).find(item => pathname.toLowerCase().startsWith(item.link.toLowerCase()));
                foundItem = foundItem || getReportMenuItems(reportViews).find(item => pathname.toLocaleLowerCase().startsWith(item.link.toLowerCase()));
                foundItem = foundItem || mainDrawerMenuBottom.find(item => pathname.toLowerCase().startsWith(item.link.toLowerCase()));
                setMainMenuLink(foundItem?.link);
                if (pathname.startsWith("/reports/") && !foundItem) {
                    e.preventDefault();
                    setMainMenuLink('/home');
                    history.push('/home');
                }
            } else {
                const foundItem = settingsDrawer.find(item => pathname.toLowerCase().startsWith(item.link.toLowerCase()));
                setSettingsMenuLink(foundItem?.link);
            }
        };
    
        if (window) {
            window.addEventListener('popstate', handleWindowPop);
        }
        return () => {
            if (window)
                window.removeEventListener('popstate', handleWindowPop);
        };
    } );

    const [venueSessionStorage, setVenueSessionStorage] = useSessionStorage(`${"selectedVenue." + user?.profile.sub}`, null);
    const selectedVenue = useSelector(
        (state) => state.venueReducer.selectedVenue
    ) ?? (venueSessionStorage);

    const reportViews = useSelector(
        (state) => state.venueReducer.reportViews
    );

    const handleMenu = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const getUser = () => {
        authService.getUser().then((user) => {
            setUser(user);
            if (user &&
                Object.values(userPermissionsConstants.ROLES).includes(user.profile.role) &&
                Object.keys(userPermissionsConstants.AVAILABLE_PAGES_BY_ROLE).includes(user.profile.role)
            ) {
                setUserAvailablePages(
                    userPermissionsConstants.AVAILABLE_PAGES_BY_ROLE[user.profile.role].map(
                        (page) => page[userPermissionsConstants.AVAILABLE_PAGE_NAME_KEY]
                    )
                );
            }
        });
    };

    const handleLogout = () => {
        authService.logout();
        setAnchorEl(null);
    }

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    useEffect(() => {
        getUser();
    }, []);
    
    useEffect(() => { 
        //saving selected venue to session 
        if (user?.profile?.sub !== undefined && selectedVenue !== undefined) {
            setVenueSessionStorage(selectedVenue);
            dispatch(selectVenue(selectedVenue));
        }
    },[selectedVenue, user?.profile.sub]) 

    useEffect(() => {
        if (selectedVenue) {
            dispatch(getReportViewsAction(selectedVenue));
        }
    }, [selectedVenue]);

    let preferred_username = "";
    if (user) preferred_username = user.profile.given_name + ' ' + user.profile.family_name; //user.profile.preferred_username;

    const [openSubMenu, setOpen] = React.useState(false);

    const handleBackToMainClick = () => {
        setShowMainMenu(true);
        history.push(mainMenuLink);
    };

    const handleSettingsClick =() => {
        setShowMainMenu(false);
        history.push(settingsMenuLink);
    };

    const handleMenuItemClick = (link) => {
        if (showMainMenu) {
            setMainMenuLink(link);
        } else {
            setSettingsMenuLink(link);
        }
    };

    useEffect(() => {
        if (mainMenuLink.startsWith("/reports/")) {
            const reportMenuItems = getReportMenuItems(reportViews);
            const foundReportMenuItem = reportMenuItems.find(it => it.link === mainMenuLink );
            if (!foundReportMenuItem) {
                setMainMenuLink("/home");
                if (showMainMenu) {
                    history.push("/home");
                }
            }
        }
    }, [reportViews]);

    // isViewingPrivateDashboard and aferHoursWarningHeight are used to determine if the business hours warning should be displayed
    // and how high it is. The height of the warning message is not fixed because the message wraps to the second line if the screen
    // is too narrow. The height of the warning message is calculated in the DashboardBusinessHoursWarning component.
    const [isViewingPrivateDashboard, setIsViewingPrivateDashboard] = useState(false);
    const location = useLocation();
    useEffect(() => {
        setIsViewingPrivateDashboard(location.pathname.startsWith("/dashboard/") && (location.search != "?editMode=true"));
    }, [location]);
    const afterHoursWarningHeight = useSelector(
        (state) => state.dashboards.afterHoursWarningHeight
    );

    const drawer = (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: 0,
        }}
      >
        <div className={classes.logoBox} style={{ textAlign: "center" }}>
          <img src="icons/OPTIC-Logo.svg" alt="" className={classes.logo}></img>
        </div>
        <Divider className={classes.divider} />

        {showMainMenu ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              flex: "1 0 0px",
              width: "auto",
              overflowX: "hidden",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                flex: "1 1 0px",
                overflowY: "auto",
                overflowX: "hidden",
                minHeight: 0,
                width: "auto",
              }}
            >
              <List>
                {getMainDrawerMenuTop(reportViews).map((item, index) => {
                  if (
                    userAvailablePages &&
                    (userAvailablePages.includes("*") ||
                      userAvailablePages.includes(item.name))
                  ) {
                    if (item.subMenu?.length > 0) {
                      //sub menu
                      return (
                        <div key={index}>
                          <ListItem
                            className={`${classes.menuItem} ${
                              item.link === mainMenuLink
                                ? classes.selectedMenuItem
                                : classes.notSelectedMenuItem
                            }`}
                            button
                            key={item.name}
                            TouchRippleProps={{
                              classes: { root: classes.touchRippleRoot },
                            }}
                            onClick={() => {
                              setOpen(!openSubMenu);
                            }}
                          >
                            <ListItemIcon className={classes.icon}>
                              {item.icon}
                            </ListItemIcon>
                            <ListItemText>
                              <Typography className={classes.menuItemName}>
                                {item.name}
                              </Typography>
                            </ListItemText>
                            {openSubMenu ? <ExpandLess /> : <ExpandMore />}
                          </ListItem>

                          <Collapse
                            in={openSubMenu}
                            timeout="auto"
                            unmountOnExit
                          >
                            <List component="div" disablePadding>
                              {item.subMenu?.map((s) => (
                                <ListItem
                                  button
                                  key={s.name}
                                  className={`${classes.nestedMenuItem} ${
                                    s.link === mainMenuLink
                                      ? classes.selectedMenuItem
                                      : classes.notSelectedMenuItem
                                  }`}
                                  component={Link}
                                  to={s.link}
                                  TouchRippleProps={{
                                    classes: { root: classes.touchRippleRoot },
                                  }}
                                  onClick={() => {
                                    handleMenuItemClick(s.link);
                                  }}
                                >
                                  <ListItemIcon></ListItemIcon>
                                  <ListItemText>
                                    <Typography
                                      className={classes.menuItemName}
                                    >
                                      {s.name}
                                    </Typography>
                                  </ListItemText>
                                </ListItem>
                              ))}
                            </List>
                          </Collapse>
                        </div>
                      );
                    } else {
                      return (
                        <ListItem
                          className={`${classes.menuItem} ${
                            item.link === mainMenuLink
                              ? classes.selectedMenuItem
                              : classes.notSelectedMenuItem
                          }`}
                          button
                          key={item.name}
                          component={Link}
                          to={item.link}
                          TouchRippleProps={{
                            classes: { root: classes.touchRippleRoot },
                          }}
                          onClick={() => {
                            handleMenuItemClick(item.link);
                            if (mobileOpen) handleDrawerToggle();
                          }}
                        >
                          <ListItemIcon className={classes.icon}>
                            {item.icon}
                          </ListItemIcon>
                          <ListItemText>
                            <Typography className={classes.menuItemName}>
                              {item.name}
                            </Typography>
                          </ListItemText>
                        </ListItem>
                      );
                    }
                  } else {
                    return null;
                  }
                })}
              </List>
              {userAvailablePages &&
              (userAvailablePages.includes("*") ||
                mainDrawerMenuBottom.filter((mainDrawerMenuBottomItem) =>
                  userAvailablePages.includes(mainDrawerMenuBottomItem.name)
                ).length > 0) ? (
                <Divider className={classes.divider} />
              ) : (
                <></>
              )}

              <List>
                {mainDrawerMenuBottom.map((item, index) => {
                  if (
                    userAvailablePages &&
                    (userAvailablePages.includes("*") ||
                      userAvailablePages.includes(item.name))
                  ) {
                    return (
                      <ListItem
                        className={`classes.menuItem ${
                          item.link === mainMenuLink
                            ? classes.selectedMenuItem
                            : classes.notSelectedMenuItem
                        }`}
                        button
                        key={item.name}
                        component={Link}
                        TouchRippleProps={{
                          classes: { root: classes.touchRippleRoot },
                        }}
                        to={item.link}
                        onClick={() => {
                          handleMenuItemClick(item.link);
                          if (mobileOpen) handleDrawerToggle();
                        }}
                      >
                        <ListItemIcon className={classes.icon}>
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText>
                          <Typography className={classes.menuItemName}>
                            {item.name}
                          </Typography>
                        </ListItemText>
                      </ListItem>
                    );
                  } else {
                    return null;
                  }
                })}
              </List>

              <Box
                sx={{
                  flexGrow: 1,
                }}
              />
            </Box>

            {/* The Settings menu item */}
            {userAvailablePages &&
            (userAvailablePages.includes("*") ||
              userAvailablePages.includes("Settings")) ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Divider className={classes.divider} />
                <ListItem
                  className={`${classes.menuItem} ${classes.notSelectedMenuItem}`}
                  button
                  key="Settings"
                  component={Link}
                  to={settingsMenuLink}
                  onClick={handleSettingsClick}
                  TouchRippleProps={{
                    classes: { root: classes.touchRippleRoot },
                  }}
                >
                  <ListItemIcon className={classes.icon}>
                    <SvgIcon
                      style={{
                        marginLeft: 0,
                        marginTop: 4,
                        transform: "scale(1.3)",
                      }}
                    >
                      <path d="M9.99999 6.66675C10.884 6.66675 11.7319 7.01794 12.357 7.64306C12.9821 8.26818 13.3333 9.11603 13.3333 10.0001C13.3333 10.8841 12.9821 11.732 12.357 12.3571C11.7319 12.9822 10.884 13.3334 9.99999 13.3334C9.11593 13.3334 8.26809 12.9822 7.64297 12.3571C7.01784 11.732 6.66665 10.8841 6.66665 10.0001C6.66665 9.11603 7.01784 8.26818 7.64297 7.64306C8.26809 7.01794 9.11593 6.66675 9.99999 6.66675ZM9.99999 8.33341C9.55796 8.33341 9.13404 8.50901 8.82148 8.82157C8.50892 9.13413 8.33332 9.55805 8.33332 10.0001C8.33332 10.4421 8.50892 10.866 8.82148 11.1786C9.13404 11.4912 9.55796 11.6667 9.99999 11.6667C10.442 11.6667 10.8659 11.4912 11.1785 11.1786C11.4911 10.866 11.6667 10.4421 11.6667 10.0001C11.6667 9.55805 11.4911 9.13413 11.1785 8.82157C10.8659 8.50901 10.442 8.33341 9.99999 8.33341ZM8.33332 18.3334C8.12499 18.3334 7.94999 18.1834 7.91665 17.9834L7.60832 15.7751C7.08332 15.5667 6.63332 15.2834 6.19999 14.9501L4.12499 15.7917C3.94165 15.8584 3.71666 15.7917 3.61666 15.6084L1.94999 12.7251C1.84165 12.5417 1.89165 12.3167 2.04999 12.1917L3.80832 10.8084L3.74999 10.0001L3.80832 9.16675L2.04999 7.80841C1.89165 7.68341 1.84165 7.45841 1.94999 7.27508L3.61666 4.39175C3.71666 4.20841 3.94165 4.13341 4.12499 4.20841L6.19999 5.04175C6.63332 4.71675 7.08332 4.43341 7.60832 4.22508L7.91665 2.01675C7.94999 1.81675 8.12499 1.66675 8.33332 1.66675H11.6667C11.875 1.66675 12.05 1.81675 12.0833 2.01675L12.3917 4.22508C12.9167 4.43341 13.3667 4.71675 13.8 5.04175L15.875 4.20841C16.0583 4.13341 16.2833 4.20841 16.3833 4.39175L18.05 7.27508C18.1583 7.45841 18.1083 7.68341 17.95 7.80841L16.1917 9.16675L16.25 10.0001L16.1917 10.8334L17.95 12.1917C18.1083 12.3167 18.1583 12.5417 18.05 12.7251L16.3833 15.6084C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9584C13.3667 15.2834 12.9167 15.5667 12.3917 15.7751L12.0833 17.9834C12.05 18.1834 11.875 18.3334 11.6667 18.3334H8.33332ZM9.37499 3.33341L9.06666 5.50841C8.06666 5.71675 7.18332 6.25008 6.54165 6.99175L4.53332 6.12508L3.90832 7.20841L5.66665 8.50008C5.33332 9.47508 5.33332 10.5334 5.66665 11.5001L3.89999 12.8001L4.52499 13.8834L6.54999 13.0167C7.19165 13.7501 8.06666 14.2834 9.05832 14.4834L9.36665 16.6667H10.6333L10.9417 14.4917C11.9333 14.2834 12.8083 13.7501 13.45 13.0167L15.475 13.8834L16.1 12.8001L14.3333 11.5084C14.6667 10.5334 14.6667 9.47508 14.3333 8.50008L16.0917 7.20841L15.4667 6.12508L13.4583 6.99175C12.8167 6.25008 11.9333 5.71675 10.9333 5.51675L10.625 3.33341H9.37499Z" />
                    </SvgIcon>
                  </ListItemIcon>
                  <ListItemText>
                    <Typography className={classes.menuItemName}>
                      Settings
                    </Typography>
                  </ListItemText>
                </ListItem>
              </Box>
            ) : null}
          </Box>
        ) : (
          <List style={{ overflowY: "auto", overflowX: "hidden" }}>
            <ListItem
              button
              className={classes.backToMain}
              key="Back to main"
              TouchRippleProps={{ classes: { root: classes.touchRippleRoot } }}
            >
              {/* <ListItemIcon className={classes.icon} ><ArrowBackIcon /></ListItemIcon> */}
              <IconButton
                size="small"
                aria-label="Back to main menu"
                onClickCapture={handleBackToMainClick}
                onMouseDown={(e) => e.stopPropagation()}
                className={classes.backToMainButton}
              >
                <ArrowBackIcon className={classes.backToMainIcon} />
              </IconButton>
              <ListItemText>
                <Typography className={classes.settingsSubmenu}>
                  Settings
                </Typography>
              </ListItemText>
            </ListItem>
            {settingsDrawer.map((item, index) => {
              return (
                <ListItem
                  className={`${classes.menuItem} ${
                    item.link === settingsMenuLink
                      ? classes.selectedMenuItem
                      : classes.notSelectedMenuItem
                  }`}
                  button
                  key={item.name}
                  component={Link}
                  to={item.link}
                  TouchRippleProps={{
                    classes: { root: classes.touchRippleRoot },
                  }}
                  onClick={() => {
                    handleMenuItemClick(item.link);
                  }}
                >
                  <ListItemIcon className={classes.icon}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText>
                    <Typography className={classes.menuItemName}>
                      {item.name}
                    </Typography>
                  </ListItemText>
                </ListItem>
              );
            })}
          </List>
        )}
      </Box>
    );

    const container = windowProp !== undefined ? () => windowProp().document.body : undefined;
    let hide = "";
    if (!user) {
        hide = "hide";
    }
    else {
        /// check expiry
        if (user.expired) { /// when expired, go to logout page
            hide = "hide";
            login();
        }
    }

    if (user &&
        !(Object.values(userPermissionsConstants.ROLES).includes(user.profile.role) &&
          Object.keys(userPermissionsConstants.AVAILABLE_PAGES_BY_ROLE).includes(user.profile.role))
    )
        return <PermissionDenied />;

    return (
        <div className={hide}>
            <ErrorBoundary>
                <div className={classes.root}>
                    <CssBaseline />

                    <AppBar position="fixed" className={classes.appBar} elevation={2}>
                        {
                            selectedVenue && isViewingPrivateDashboard ?
                                <DashboardBusinessHoursWarning venue={selectedVenue} /> 
                                : null 
                        }
                        <Box
                            sx={{
                                display: "grid"
                            }}
                        >
                            <Toolbar
                                style={{
                                    gridColumn: 1,
                                    gridRow: 1,
                                }}
                            >
                                <IconButton
                                    color="primary"
                                    aria-label="open drawer"
                                    edge="start"
                                    onClick={handleDrawerToggle}
                                    className={classes.menuButton}
                                >
                                    <MenuIcon />
                                </IconButton>
                                {selectedVenue ?
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "stretch",
                                            flexGrow: 1,
                                            minWidth: 0
                                        }}
                                    >
                                        <Typography
                                            variant="h5"
                                            noWrap
                                            className={classes.currentVenueLabel}
                                        >Current venue: </Typography>
                                        <Typography
                                            variant="h5"
                                            noWrap
                                            className={classes.currentVenueName}
                                        >{selectedVenue.name}</Typography>
                                    </Box>
                                    :
                                    <Typography
                                        variant="h5"
                                        noWrap
                                        className={classes.title}
                                    >
                                        Please, select venue to manage
                                    </Typography>
                                }

                                <NotificationPanel />

                                <div>
                                    <Chip
                                        label={preferred_username}
                                        avatar={<AccountCircle className={classes.accountCircle} />}
                                        onClick={handleMenu}         
                                        style={{backgroundColor: theme.palette.color.primary.background}}
                                    />
                                    <Menu
                                        id="profile-menu"
                                        anchorEl={anchorEl}
                                        getContentAnchorEl={null}
                                        anchorOrigin={{
                                            vertical: "bottom",
                                            horizontal: "right",
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: "top",
                                            horizontal: "right",
                                        }}
                                        open={open}
                                        onClose={handleClose}
                                    >
                                        <MenuItem component={Link} to="/user-profile">
                                            <Person className={classes.userProfileMenuIcon} />
                                            Profile
                                        </MenuItem>
                                        <MenuItem onClick={handleLogout}>
                                            <ExitToApp className={classes.userProfileMenuIcon} />
                                            Sign out
                                        </MenuItem>
                                    </Menu>
                                </div>
                            </Toolbar>
                            {
                                isViewingPrivateDashboard && afterHoursWarningHeight ?
                                <Box
                                    className={`${classes.afterHoursMainCurtain} ${classes.afterHoursToolbarCurtain}`}
                                    style={{
                                        gridColumn: 1,
                                        gridRow: 1,
                                    }}
                                /> : null
                            }
                        </Box>
                    </AppBar>
                    <nav className={classes.drawer} aria-label="mailbox folders">
                        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                        <Hidden smUp implementation="css">
                            <Drawer
                                container={container}
                                variant="temporary"
                                anchor={theme.direction === "rtl" ? "right" : "left"}
                                open={mobileOpen}
                                onClose={handleDrawerToggle}
                                classes={{
                                    paper: classes.drawerPaper,
                                }}
                                ModalProps={{
                                    keepMounted: true, // Better open performance on mobile.
                                    animation: "false"
                                }}
                            >
                                {drawer}
                            </Drawer>
                        </Hidden>
                        <Hidden xsDown implementation="css">
                            <Drawer
                                classes={{
                                    paper: classes.drawerPaper,
                                }}
                                variant="permanent"
                                open
                            >
                                {drawer}
                            </Drawer>
                        </Hidden>
                    </nav>
                    <Box
                        sx={{
                            display: "grid",
                            flexGrow: 1
                        }}
                    >
                        <main 
                            className={classes.content} 
                            name="main"
                            style={{
                                gridColumn: 1,
                                gridRow: 1,
                            }}
                        >
                            <div style={{height: isViewingPrivateDashboard && afterHoursWarningHeight ? `${64+afterHoursWarningHeight}px`: "64px"}} />
                            <div className={classes.pageContent}>
                                <MyRoutes />
                            </div>
                        </main>
                        {
                            isViewingPrivateDashboard && afterHoursWarningHeight ?
                            <Box
                                className={classes.afterHoursMainCurtain}
                                style={{
                                    gridColumn: 1,
                                    gridRow: 1,
                                }}
                            /> : null
                        }  
                    </Box>
                    <div className={classes.helpContainer}>
                        <div className={classes.helpButton}  onClick={(e) => {
                            let myFrame = document.getElementById("myIframe").style.display;
                            if (myFrame === "block")
                                document.getElementById("myIframe").style.display = "none";
                            else
                                document.getElementById("myIframe").style.display = "block";
                        }} >
                            <Tooltip title="OPTIC User Guide">
                                <HelpOutlineIcon style={{fontSize: 40}} /> 
                            </Tooltip>
                        </div>
                        <iframe id="myIframe" 
                                src={process.env.REACT_APP_AI_BOT_URL}
                                className={classes.helpIframe}  name="codyai" scrolling="no" frameBorder="1"
                                marginHeight="0" marginWidth="0" height="550px" width="350px"
                                allow={"fullscreen"} ></iframe>
                    </div>
                </div>
                <ToastContainer
                    enableMultiContainer
                    autoClose={3000}
                    hideProgressBar
                    position={toast.POSITION.BOTTOM_LEFT}
                    newestOnTop
                />
            </ErrorBoundary>
        </div>
    );
};

function mapStateToProps(state) {

    return {
    };
}

const connectedHomePage = connect(mapStateToProps)(Home);
export { connectedHomePage as Home };